import {AuthorizationService, Token} from "../services/AuthorizationService";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import { Navigate } from "react-router-dom";

export interface Parameters {
    grant_type: string
    client_id: string
    redirect_uri: string
    code_verifier: string | null
    code: string
}

export default function Login() {

    const authorizationServer = new AuthorizationService()

    const queryClient = useQueryClient()

    function getParams(): Parameters {
        const currentURL = window.location.href
        currentURL.indexOf("?code")
        let code = currentURL.split("?code=")[1]
        return {
                grant_type: "authorization_code",
                client_id: "client",
                redirect_uri: process.env.REACT_APP_REDIRECT_URI + "",
                code_verifier: window.sessionStorage.getItem("CODE_VERIFIER"),
                code: code
        }
    }

    function useGetToken (params: Parameters) {
        return useQuery({
            queryKey: [
                "tokenKey",
                params.code_verifier,
            ],
            queryFn: async () => {
                    return await authorizationServer.getToken(params)
            },
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        })
    }

    const {
        data: token,
        isFetching: tokenIsFetching
    } = useGetToken(getParams())

    if (!tokenIsFetching && token) {
        window.sessionStorage.setItem("TOKEN", token.access_token)
        return <Navigate to="/partner" replace={true} />
    }
        else return null
}